export default "/build/images/add-station.187370ca.png";